import { useLocation, Link, useParams } from "react-router-dom";
import { CheckCircle2 } from "lucide-react";
import { currency } from "@/lib/api";
import { Button } from "@/components/ui/button";

export default function OrderConfirmation() {
  const location = useLocation();
  const { id } = useParams();
  const order = location.state;

  return (
    <div data-testid="order-confirmation-page" className="max-w-3xl mx-auto px-6 py-24 text-center">
      <div className="inline-flex h-16 w-16 items-center justify-center rounded-full bg-[#1e392a]/10 mb-6">
        <CheckCircle2 className="h-8 w-8 text-[#1e392a]" strokeWidth={1.5} />
      </div>
      <p className="overline">Order confirmed</p>
      <h1 className="mt-2 font-serif text-4xl sm:text-5xl text-[#1e392a] tracking-tight">
        Thank you for your ritual.
      </h1>
      {order?.order_number && (
        <p className="mt-4 text-sm text-[#8a8d86]">
          Order <span data-testid="conf-order-number" className="font-medium text-[#1e392a]">{order.order_number}</span>
        </p>
      )}
      {order?.total != null && (
        <p className="mt-2 text-sm text-[#8a8d86]">
          Total: <span data-testid="conf-order-total" className="font-medium text-[#1e392a]">{currency(order.total)}</span>
        </p>
      )}

      <div className="mt-10 bg-white border border-[#e6e2d8] rounded-md p-8 text-left">
        <p className="text-sm text-[#1a1b1a]/80">
          We've received your order and will begin preparing it shortly. You'll receive a shipping
          confirmation once it's on the way.
        </p>
        {order?.payment_method === "cod" && (
          <p className="mt-4 text-sm text-[#c36a4f]">
            Payment method: Cash on Delivery. Please have exact change ready.
          </p>
        )}
      </div>

      <div className="mt-8 flex gap-3 justify-center">
        <Link to="/shop">
          <Button
            data-testid="conf-continue-shopping"
            className="rounded-full bg-[#1e392a] hover:bg-[#14251b] text-white h-12 px-8"
          >
            Continue shopping
          </Button>
        </Link>
        <Link to="/account">
          <Button
            variant="ghost"
            data-testid="conf-view-orders"
            className="rounded-full h-12 px-8 hover:bg-[#efeadd]"
          >
            View my orders
          </Button>
        </Link>
      </div>
    </div>
  );
}
